export async function affExternalShipmentsPrepareUseCase(orders, externalShipmentRepository) {

    const result = await externalShipmentRepository.aff_prepare_orders(orders);
    
    const entity = new externalShipmentRepository.aff_prepare_model(result.data);

    if (!entity.isValid()) {
        console.log(entity)
        throw new Error("External Shipments Aff Prepare Inválido");
    }
    
    return result;
}